import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// Zoom enforces a 10 second wait before you can attempt to call join() again
const ZOOM_JOIN_TIMEOUT = 10;

export default function ZoomJoinCountdownWrapper({ joinButton, isOpen, isPreviouslyOpen }) {
    const [countdown, setCountdown] = useState(null);
    const countdownIntervalRef = useRef(null);

    const decrementTimer = () => {
        setCountdown(countdown - 1);
    };

    useEffect(() => {
        const shouldInitializeCountdown = !isOpen && isPreviouslyOpen;

        if (shouldInitializeCountdown) {
            setCountdown(ZOOM_JOIN_TIMEOUT);
        }
    }, [isOpen, isPreviouslyOpen]);

    useEffect(() => {
        if (typeof countdown === 'number' && countdown <= 0) {
            clearInterval(countdownIntervalRef.current);
            setCountdown(null);
        } else if (countdown) {
            countdownIntervalRef.current = setInterval(decrementTimer, 1000);
        }

        return () => countdownIntervalRef.current && clearInterval(countdownIntervalRef.current);
    }, [countdown]);

    return countdown > 0 ? <div>You can re-join this meeting in {countdown} seconds</div> : joinButton;
}

ZoomJoinCountdownWrapper.propTypes = {
    joinButton: PropTypes.node.isRequired,
    isOpen: PropTypes.bool.isRequired,
    isPreviouslyOpen: PropTypes.bool.isRequired,
};
